import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2e39344b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=2e39344b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39344b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e39344b')) {
      api.createRecord('2e39344b', component.options)
    } else {
      api.reload('2e39344b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2e39344b&scoped=true&", function () {
      api.rerender('2e39344b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KbbYM7UFpNkf/JS/comp/SearchFilterTokens.vue"
export default component.exports